module.exports = __webpack_public_path__ + "static/img/btn_download.0f5243b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/btn_download.svg
// module id = 90
// module chunks = 0